module.exports = __webpack_public_path__ + "img/13_1.fd0e76c6.jpg";